// extracted by mini-css-extract-plugin
export default {"app":"BottomAlert_app__h-2RA","mask":"BottomAlert_mask__5JTqZ","content":"BottomAlert_content__2WCP8","view":"BottomAlert_view__RzOId","inputBox":"BottomAlert_inputBox__sl8jQ"};